export default __webpack_public_path__ + "static/media/039-bomb.9f7c5f65.png";